export const configs = {
  API_URL: import.meta.env.VITE_API_URL,
}
